import React from "react";
import { Timeline, Tag, Empty } from "antd";
import { ToolOutlined, FileTextOutlined, LockOutlined, ClockCircleOutlined, EditOutlined, PaperClipOutlined } from "@ant-design/icons";
import moment from "moment";

// Renders a merged, chronological asset timeline (service / inspection /
// activity events) from the data returned by assetService.getTimeline.
const TYPE_META = {
  service: { color: "blue", icon: <ToolOutlined /> },
  inspection: { color: "green", icon: <FileTextOutlined /> },
  activity: { color: "gray", icon: <ClockCircleOutlined /> },
};

const eventColor = (event) => {
  if (event.type === "inspection" && event.meta && event.meta.status === "fail") {
    return "red";
  }
  const subtype = String(event.subtype || "");
  if (event.type === "activity") {
    if (subtype.includes("lock_out")) return "volcano";
    if (subtype === "attachment_removed") return "red";
    if (subtype === "attachment_added") return "cyan";
    if (subtype === "updated") return "geekblue";
  }
  return (TYPE_META[event.type] || {}).color || "gray";
};

const eventIcon = (event) => {
  const subtype = String(event.subtype || "");
  if (event.type === "activity") {
    if (subtype.includes("lock_out")) return <LockOutlined />;
    if (subtype.startsWith("attachment_")) return <PaperClipOutlined />;
    if (subtype === "updated") return <EditOutlined />;
  }
  return (TYPE_META[event.type] || {}).icon || <ClockCircleOutlined />;
};

const formatDate = (d) => {
  if (!d) return "";
  const m = moment(d);
  return m.isValid() ? m.format("ll") : d;
};

const AssetTimeline = ({ events = [] }) => {
  if (!events.length) {
    return <Empty description="No history yet" />;
  }
  return (
    <Timeline mode="left">
      {events.map((event, idx) => (
        <Timeline.Item key={idx} color={eventColor(event)} dot={eventIcon(event)}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <strong>{event.title}</strong>
            <span style={{ color: "rgba(0,0,0,0.45)" }}>{formatDate(event.date)}</span>
          </div>
          {event.summary ? <div style={{ color: "#555" }}>{event.summary}</div> : null}
          {event.type === "service" && event.meta && Array.isArray(event.meta.items) && (
            <div style={{ marginTop: 4 }}>
              {event.meta.items.map((it, i) => (
                <Tag key={i} color="blue">
                  {it.action}
                  {it.description ? `: ${it.description}` : ""}
                </Tag>
              ))}
            </div>
          )}
        </Timeline.Item>
      ))}
    </Timeline>
  );
};

export default AssetTimeline;
